namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoTypeForm {
        PmType: Serenity.IntegerEditor;
        PmTypeDesc: Serenity.StringEditor;
        PmTypeOrder: Serenity.IntegerEditor;
    }

    export class PsAdvPromoTypeForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoTypeForm.init)  {
                PsAdvPromoTypeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PsAdvPromoTypeForm, [
                    'PmType', w0,
                    'PmTypeDesc', w1,
                    'PmTypeOrder', w0
                ]);
            }
        }
    }
}
